import { render } from "./BaseRadioButton.vue?vue&type=template&id=926856a0"
import script from "./BaseRadioButton.vue?vue&type=script&lang=js"
export * from "./BaseRadioButton.vue?vue&type=script&lang=js"

import "./BaseRadioButton.vue?vue&type=style&index=0&id=926856a0&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__